var fields = ['place_id', 'geometry', 'name', 'formatted_address'];

var mapsScriptInjected = false;

export function injectMapScript () {
  if (!mapsScriptInjected) {
    var placeScript = document.createElement('script');
    placeScript.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBHpEudkaJz_RnsBeyqrFvmgxhhqbG9ViM&libraries=places';
    document.head.appendChild(placeScript);
    mapsScriptInjected = true;
  }
}

export class PlaceEventHandler {
  origin = null;
  map = null;
  placesService = null;
  infowindow = null;
  infowindowContent = null;
  opts = null;
  marker = null;
  autocomplete = null;

  constructor(map, origin, opts) {
    this.origin = origin;
    this.map = map;
    this.placesService = new google.maps.places.PlacesService(map);
    this.infowindow = new google.maps.InfoWindow;
    this.infowindowContent = document.getElementById('infowindow-content');
    this.infowindow.setContent(this.infowindowContent);
    this.opts = opts;
    this.marker = new google.maps.Marker({map: this.map});

    var input = document.getElementById('pac-input');
    this.autocomplete = new google.maps.places.Autocomplete(input);
    this.autocomplete.bindTo('bounds', map);

    this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
    // Specify just the place data fields that you need.
    this.autocomplete.setFields(fields);

    if (this.opts.place_id) {
      this.setPlace(this.opts.place_id, true);
    }

    var me = this;
    this.autocomplete.addListener('place_changed', function () {
      me.infowindow.close();
      var place = me.autocomplete.getPlace();
      me.setPlace(place.place_id, false);
    });

    // Listen for clicks on the map.
    this.map.addListener('click', this.handleClick.bind(this));
  }

  setPlace(placeId, currentlyUsing=false) {

    this.marker.addListener('click', function () {
      this.infowindow.open(this.map, marker);
    });

    var me = this;
    loadPlaceFromId(placeId);

    function loadPlaceFromId (id) {
      var request = {
        placeId: id,
        fields: fields
      };

      var service = me.placesService;
      service.getDetails(request, function (place, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          loadPlace(place);
        }
      });
    }

    function loadPlace (place) {
      if (!place.geometry) {
        return;
      }

      if (place.geometry.viewport) {
        me.map.fitBounds(place.geometry.viewport);
      } else {
        me.map.setCenter(place.geometry.location);
        me.map.setZoom(17);
      }

      // Set the position of the marker using the place ID and location.
      me.marker.setPlace({
        placeId: place.place_id,
        location: place.geometry.location
      });

      me.marker.setVisible(true);

      me.infowindowContent.children['place-name'].textContent = place.name;
      if (currentlyUsing) {
        me.infowindowContent.children['place-choose'].textContent = "Currently Using";
      } else {
        me.infowindowContent.children['place-choose'].textContent = "Use Place";
      }
      me.infowindowContent.children['place-choose'].onclick = function () {
        if (me.opts.callback) {
          me.opts.callback(place.place_id);
        }
      }
      me.infowindowContent.children['place-address'].textContent = place.formatted_address;
      me.infowindow.open(me.map, me.marker);
    }
  }

  handleClick(event) {
    console.log('You clicked on: ' + event.latLng);
    // If the event has a placeId, use it.
    if (event.placeId) {
      console.log('You clicked on place:' + event.placeId);

      // Calling e.stop() on the event prevents the default info window from
      // showing.
      // If you call stop here when there is no placeId you will prevent some
      // other map click event handlers from receiving the event.
      event.stop();
      this.setPlace(event.placeId, false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/PlaceEventHandler.js